import BaseFormPage from "../../../base/BaseFormPage";
import RoleFormPresenter from "../../role-form/RoleFormPresenter";
import { getObjectUseCase, upsertUseCase } from "../../../usecases/object";
import { updateSchemaUseCase } from "../../../usecases/schema/usecases";
import withRouter from "../../../withRouter";
import InputFactory from "../../../components/InputFactory";
import CardView from "../../../components/common/CardView";

class HealthCheckPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = { url: "", domain: "", username: "", password: "" };
    this.presenter = new RoleFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase(),
      updateSchemaUseCase()
    );
  }

  handleSubmitInput(field, value) {
    this.setState({ [field]: value });
  }

  handleTestConnection() {
    const { url, domain, username, password } = this.state;
    const data = {
      url,
      domain,
      username,
      password,
    };

    alert("Active Directory Health Check");
    console.warn("DATA: ", data);
  }

  render() {
    return (
      <>
        <div className="overflow-auto mt-5">
          <div className="p-3 p-lg-4 mt-3">
            <div
              className="d-flex m-4"
              style={{ borderBottom: "1.5px solid #d3d3d3" }}
            >
              <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                You are here: Home {">"} System Administration {">"}{" "}
                <span style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}>
                  Active Directory Health Check
                </span>
              </p>
            </div>
            <div className="m-4">
              <CardView style={{ padding: 0, borderRadius: 0 }}>
                <h4 className="text-primary pt-4 ps-4 mb-3">
                  Active Directory
                </h4>
                <div className="border" />
                <div className="row p-0">
                  <div className="col-lg-6 p-4 border-end">
                    {["url", "domain", "username", "password"].map(
                      (label, index) => {
                        const labelDisplay = {
                          url: "Active Directory URL (LDAP Url):",
                          domain: "Active Directory Base Domain:",
                          username: "Active Directory Username:",
                          password: "Active Directory Password:",
                        };
                        return (
                          <div className="ps-3 pe-3 mb-5 fs-sm" key={index}>
                            <label className="mb-2">
                              {labelDisplay[label]}
                            </label>
                            <InputFactory
                              required
                              value={this.state[label]}
                              type={
                                label === "password" ? "Password" : "String"
                              }
                              onChange={(value) =>
                                this.handleSubmitInput(label, value)
                              }
                            />
                            {label === "username" && (
                              <span style={{ color: "grey" }}>
                                The username and password specified in the
                                configuration are what are used for user and
                                group lookup operations.
                              </span>
                            )}
                          </div>
                        );
                      }
                    )}
                    <hr />
                    <div className="text-end">
                      <button
                        className="btn btn-primary"
                        onClick={this.handleTestConnection.bind(this)}
                      >
                        Test Connection
                      </button>
                    </div>
                  </div>
                  <div className="col-lg-6 h-50">
                    <div className="pt-5 pb-5 ps-4 pe-4">
                      <h6 className="fw-bold">Result</h6>

                      <div
                        className="border p-4 fs-sm"
                        style={{ height: "25rem" }}
                      >
                        {/* Result  */}
                      </div>
                    </div>
                  </div>
                </div>
              </CardView>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(HealthCheckPage);
